export enum PlanTypesEnum {
  Trial = 'TRIAL',

  Bronze = 'BRONZE',
  Silver = 'SILVER',
  Gold = 'GOLD',

  LegacyGood = 'GOOD',
  LegacyBetter = 'BETTER',
  LegacyBest = 'BEST',

  LegacyLite = 'LITE',
  LegacyGrowth = 'GROWTH',

  Free = 'FREE',

  /**
   * "Mobile free" plan type
   *
   * Eventually this will be deprecated in favor of the "Free" type.
   *
   * @see https://ctct.slack.com/archives/C02A08V79FY/p1742840431106979?thread_ts=1742839682.792599&cid=C02A08V79FY
   */
  MobileFree = 'MOBILEFREE',

  ProPackage = 'PRO',
}

export enum SocialStarterPlanTypesEnum {
  Free = 'SOCIAL_FREE',
  Trial = 'TRIAL',
  Bronze = 'SOCIAL_BRONZE',
  Silver = 'SOCIAL_SILVER',
}

export enum EventsV1PlanTypesEnum {
  Free = 'EVENTS_FREE',
  Bronze = 'EVENTS_BRONZE',
  Silver = 'EVENTS_SILVER',
  Gold = 'EVENTS_GOLD',
}

const PlanIds = {
  STANDARDV21PREMIUM: 216,
  LARGELISTPREMIUMV23: 363,
  AUSTRALIA_V1_PREMIUM: 688,
  NEWZEALAND_V1_PREMIUM: 691,
  GREATBRITAIN_V1_PREMIUM: 694,
};

export const PremiumPlanIds = [
  PlanIds.STANDARDV21PREMIUM,
  PlanIds.LARGELISTPREMIUMV23,
  PlanIds.AUSTRALIA_V1_PREMIUM,
  PlanIds.NEWZEALAND_V1_PREMIUM,
  PlanIds.GREATBRITAIN_V1_PREMIUM,
];
